module.exports={
    shop: {
        store:'店舗',
        stores:{
        	findPro:'店舗を検索',
        	allPro:'全店',
            info:'店舗情報',
            uuid:'番号',
            address:'住所'
        },
        menus:[
            {
                name:'overview',
                key:'overview',
                text:'概観'
            },{
                name:'products',
                key:'products',
                text:'グッズ'
            },{
                name:'label',
                key:'label',
                text:'棚札'
            },{
                name:'gateway',
                key:'gateway',
                text:'ゲートウェイ'
            },{
                name:'record',
                key:'record',
                text:'記録'
            },{
                name:'shopsTemplates',
                key:'shopsTemplates',
                text:'テンプレート'
            },{
                name:'import',
                key:'import',
                text:'インポート'
            },{
                name:'settings',
                key:'settings',
                text:'設定'
            }
        ],
        overview:'概観',
        products:'グッズ',
        label:'棚札',
        gateway:'ゲートウェイ',
        record:'記録',
        authorization:'承認する',
        shopsTemplates:'テンプレート',
        import:'インポート',
        settings:'設定',
        submiting:'提出中...',
        storeMember:{
        	addMember:'店舗メンバーを追加',
        	members:'店舗会員'
        },
        warning:{
            title:'警告メッセージ',
            selected:{
                brushFailed:'更新失敗',
                upgradeFailed:'アップグレード失敗',
                bindFailed:'連携失敗'
            },
            bandTotal: 'バインディングの総数：',
            bandFailed: '連携失敗の番号：',
            reUpdate:'再描画',
            reUgrade:'アップグレードする',
            failed:'警告メッセージの検索に失敗しました',
            noData:'データなし',
            esl:'棚札 ',
            rebrushSuccess:'再ブラシコマンドが正常に送信されました',
            rebrushFailed:'再描画コマンドの送信に失敗しました',
            reupgradeSuccess:'アップグレード手順が正常に送信されました。タグファームウェアのアップグレード中はゲートウェイをオンラインにしてください...',
            reupgradeFailed:'アップグレードの指示を送信できませんでした',

            batchRebrushFailed:'バッチ再描画コマンドの送信に失敗しました',
            batchReupgradeFailed:'バッチアップグレードコマンドの送信に失敗しました',

            noCheck:'更新する棚札を確認してください',
            noBind:'棚札はゲートウェイに連携されていません',
            updated:'この棚札は更新されました',
            noUpgradePackage:'アップグレードパッケージが削除されたか、存在しません',
            versionError: 'アップグレードパッケージバージョンエラー',
            labelError: '異常な棚札',

            batchRebrushNoBind:'再描画コマンドの送信に失敗しました。棚札はゲートウェイに連携されていません',
            batchRebrushUpdated:'再描画コマンドを送信できませんでした。この棚札は更新されています',

            batchReupgradeNoBind:'アップグレード指示の送信に失敗した、棚札がゲートウェイに連携されていない、またはアップグレードパッケージが存在しない',
            batchReupgradeUpdated:'アップグレードの指示を送信できませんでした。このデバイスは存在しません'

        },
        progress:{
            brush:'スワイプ',
            upgrade:'ファームウェアのアップグレード',
            bind:'連携',
            brushTotal:'合計：',
            brushSuccess:'成功数：',
            upgradeTotal:'合計：',
            upgradeSuccess:'成功数：',
            bingingTotal:'合計：',
            bingingSuccess:'成功数：',
            getProgressFailed:'進行状況バーに関連するデータを取得できませんでした',
            resetProgressFailed:'現在のストアのプログレスバーデータをリセットできませんでした'
        },
        addMemberTable:{
        	addMember:'メンバーを追加',
        	findMember:'メンバーを検索',
        	chooseMember:'メンバーを選択',
        	noData:'データなし',
            add:'追加'
        },
        sure:'確定',
        member:'店舗会員',
        hintMsg:{
            queryStoreFail:'店舗への問い合わせなし',
            queryAllStoreFail:'すべての店舗情報の検索に失敗しました',
            queryUndistributedUser:'配置られていないストアのユーザーは見つかりませんでした',
            distributedMemberSuccess:'店舗へのメンバーの配置に成功しました',
            distributedMemberFail:'ストアへのメンバーの配置に失敗しました',
            // missPara:'リクエストパラメータがありません',
            chooseMember:'メンバーを選択してください',
            queryMemberFail:'ストアメンバーの検索に失敗しました',
            queryStoreInfoFail:'店舗情報の取得に失敗しました',
            alreadyDistributed:'メンバーはストアに配置られました'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/shop.js